<div class="flex justify-center items-center min-h-screen bg-[#172C41] px-4">
  <div class="max-w-md w-full bg-[#FFF8F4] rounded-[4px] p-6 shadow-md text-center">
    <img src="/assets/images/logo1.png" alt="Logo Sitrack" class="mb-5 w-85 mx-auto">

    <!-- Error Display -->
    @if (errorMessage) {
      <div
        class="flex items-start p-3 sm:p-4 mb-4 rounded-lg border-l-4 relative"
        [class.bg-red-50]="currentError?.type === 'error' || !currentError?.type"
        [class.border-l-red-500]="currentError?.type === 'error' || !currentError?.type"
        [class.text-red-800]="currentError?.type === 'error' || !currentError?.type"
        [class.bg-amber-50]="currentError?.type === 'warning'"
        [class.border-l-amber-500]="currentError?.type === 'warning'"
        [class.text-amber-800]="currentError?.type === 'warning'"
        [class.bg-blue-50]="currentError?.type === 'info'"
        [class.border-l-blue-500]="currentError?.type === 'info'"
        [class.text-blue-800]="currentError?.type === 'info'"
      >
        <span class="mr-2 sm:mr-3 mt-0.5 flex-shrink-0">
          @switch (currentError?.type) {
            @case ('warning') {
              <svg xmlns="http://www.w3.org/2000/svg" class="size-5 sm:size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M12 9v4m0 4h.01M10.6 3.8a2 2 0 0 1 2.8 0l8.5 8.5a2 2 0 0 1-1.4 3.4H3.5a2 2 0 0 1-1.4-3.4l8.5-8.5z"/>
              </svg>
            }
            @case ('info') {
              <svg xmlns="http://www.w3.org/2000/svg" class="size-5 sm:size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 16v-4m0-4h.01"/>
              </svg>
            }
            @default {
              <svg xmlns="http://www.w3.org/2000/svg" class="size-5 sm:size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <circle cx="12" cy="12" r="10"/>
                <path d="M15 9l-6 6m0-6l6 6"/>
              </svg>
            }
          }
        </span>
        <div class="flex-1">
          <h4 class="m-0 mb-2 font-medium text-sm sm:text-base">{{ currentError?.title || 'Error' }}</h4>
          <p class="m-0 text-xs sm:text-sm leading-relaxed text-start" [innerHTML]="formatErrorMessage(currentError?.message || errorMessage)"></p>
          @if (shouldShowRetry) {
            <button
              (click)="retryLastAction()"
              class="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-[4px] font-medium text-sm border border-[#172C41] text-[#172C41] cursor-pointer transition-colors hover:bg-[#172C41]/5"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M1 4v6h6M23 20v-6h-6"/>
                <path d="M20.5 6A9 9 0 0 0 4.3 10M3.5 18A9 9 0 0 0 19.7 14"/>
              </svg>
              Reintentar
            </button>
          }
        </div>
        <button
          (click)="clearError()"
          class="absolute top-1 sm:top-2 right-1 sm:right-2 p-1 rounded-[4px] text-current cursor-pointer transition-colors hover:bg-black/5"
          aria-label="Cerrar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
    }

    <!-- Loading Indicator -->
    @if (isLoading()) {
      <div class="mb-4 text-center">
        <div class="w-full h-1 bg-gray-200 rounded overflow-hidden">
          <div class="h-full bg-[#F99C1E] w-1/2 rounded animate-indeterminate"></div>
        </div>
        <p class="mt-2 mb-0 text-sm text-gray-600">{{ loadingMessage }}</p>
      </div>
    }

    @if (!otpSent()) {
      <app-email-input
        [disabled]="isLoading()"
        (emailSubmitted)="handleEmailSubmit($event)">
      </app-email-input>
    } @else {
      <app-otp-input
        [email]="userEmail"
        [disabled]="isLoading()"
        (otpSubmitted)="handleOtpSubmit($event)"
        (backToEmail)="handleBackToEmail()">
      </app-otp-input>
    }

  </div>
</div>
